/* __next_internal_client_entry_do_not_use__ LoadingSkeleton auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import * as React from "react";
import { LoadingSkeletonBase } from "./LoadingSkeletonBase";
/**
 * @trackcomponent
 */ export var LoadingSkeleton = function(_param) {
    var ariaLabel = _param.ariaLabel, rest = _object_without_properties(_param, [
        "ariaLabel"
    ]);
    var strictLocalize = useStrictLocalization().strictLocalize;
    var ariaLabelWithFallback = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : strictLocalize({
        id: "eyTJgl",
        defaultMessage: [
            {
                type: 0,
                value: "Loading"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(LoadingSkeletonBase, _object_spread_props(_object_spread({}, rest), {
        ariaLabel: ariaLabelWithFallback
    }));
};
